import { footerMenu } from './elements.js';

/**
 * Remove :focus outline unless user is using the keyboard to navigate
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function handleFirstTab(e) {
  if (e.key === 'Tab') {
    document.body.classList.add('h-user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('h-user-is-tabbing');
  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
}

/**
 * Fix full-bleed overflow with visible scrollbars
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function scrollbarFix() {
  const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;

  if (hasScrollbar) {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    const fullBleedEls = document.querySelectorAll('.h-full-bleed');

    fullBleedEls.forEach((el) => {
      el.style.setProperty(
        '--full-bleed-width',
        `calc(100vw - ${scrollbarWidth}px)`
      );
      el.style.setProperty(
        '--full-bleed-margin',
        `calc(50% - 50vw + ${scrollbarWidth / 2}px)`
      );
    });
  }
}

/**
 * Disable animations on resize
 *
 * @author      Andy Bell
 * @version     1.0.0
 * @see         https://css-tricks.com/stop-animations-during-window-resizing/
 */

let resizeTimer;
export function disableAnimationOnResize() {
  document.body.classList.add('h-js-resize-animation-stopper');
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove('h-js-resize-animation-stopper');
  }, 400);
}

/**
 * Change item height
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function changeElementHeight(el, height) {
  el.style.height = `${height}px`;
}
